
<template>
    <el-main>
        <div style="margin-bottom: 15px; display: flex;flex-flow: row;justify-content:flex-start">
            <el-input placeholder="请输入仪器设备名称" v-model="instrName" style="width: 300px" >
            </el-input>
            <el-button type="primary" plain @click="sele" style="margin-left: 10px">搜索</el-button>
            <el-button type="primary" plain @click="refresh" style="margin-left: 10px">刷新</el-button>
            <el-button type="primary" plain @click="handleAdd" style="margin-left: 10px">新建仪器</el-button>
            <el-button  type="primary" plain  @click=" $router.push('/tool')" style="margin-right: 20px">上一步</el-button>
        </div>

        <div>
            <el-table :data="instrument" border style="width: 180%">
                <el-table-column prop="toolId" label="仪器组号" ></el-table-column>
                <el-table-column prop="instrName" label="仪器设备名称" ></el-table-column>
                <el-table-column prop="instrNo" label="规格型号"></el-table-column>
                <el-table-column prop="instrNum" label="仪器设备编号"></el-table-column>


                <el-table-column label="操作">
                    <template v-slot="scope">
                        <el-button  type="primary" plain size="small" @click="toupdate(scope.row)">编辑</el-button>
                        <el-button  type="danger" plain size="small" @click="dele(scope.row.instrumentId)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>


        <el-dialog v-model="formVisible" title="添加仪器" :lock-scroll="false" width="45%" draggable>
            <el-form ref="form" :model="form" status-icon label-width="160px" :rules="rules">

                <el-form-item label="仪器设备名称" prop="instrName">
                    <el-input  v-model="form.instrName"></el-input>
                </el-form-item>
                <el-form-item label="规格型号" prop="instrNo">
                    <!--                    <el-input  v-model="form.instrNo" @change="nameCheck1"></el-input>-->
                    <el-input  v-model="form.instrNo" ></el-input>
                </el-form-item>
                <el-form-item label="仪器设备编号" prop="instrNum">
                    <!--                    <el-input  v-model="form.instrNum" @change="nameCheck2"></el-input>-->
                    <el-input  v-model="form.instrNum" ></el-input>
                </el-form-item>
            </el-form>

            <template #footer>
                      <span class="dialog-footer" >
                        <el-button style="margin-top: -40px" @click="formVisible = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="save1"
                        >确定</el-button
                        >
                      </span>
            </template>
        </el-dialog>

        <el-dialog v-model="form2Visible" title="编辑仪器" :lock-scroll="false" width="45%" draggable >
            <el-form ref="form2" :model="form2" status-icon label-width="160px" :rules="rules" >

                <el-form-item label="仪器设备名称" prop="instrName">
                    <el-input  v-model="form2.instrName"></el-input>
                </el-form-item>
                <el-form-item label="规格型号"  prop="instrNo">
                    <!--                    <el-input  v-model="form2.instrNo"  @change="nameCheck1"></el-input>-->
                    <el-input  v-model="form2.instrNo" ></el-input>
                </el-form-item>
                <el-form-item label="仪器设备编号" prop="instrNum">
                    <!--                    <el-input  v-model="form2.instrNum" @change="nameCheck2"></el-input>-->
                    <el-input  v-model="form2.instrNum" ></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                      <span class="dialog-footer" >
                        <el-button style="margin-top: -40px" @click="form2Visible = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="save2"
                        >确定</el-button
                        >
                      </span>
            </template>
        </el-dialog>
    </el-main>
</template>


<script>
    import request from "../../util/request";

    export default {

        // eslint-disable-next-line vue/multi-word-component-names
        name: 'Instrument.vue',
        data(){
            return{
                reData:{},
                checked1:false,
                checked2:false,
                instrName:'',
                instrNo:'',
                instrNum:'',
                instrument:[],
                ticket:[],
                formVisible:false,
                form:{
                    instrNo:'',
                    instrNum:'',
                    instrName:'',
                },
                form2Visible:false,
                form2:{
                    instrNo:'',
                    instrNum:'',
                    instrName:'',
                },
                currentPage: 1,
                total:0,
                pageSize:5,
                pageSizes:[5, 10, 15, 20,25,30],
                options: [],
                value1: [],
                value2:[],
                //接收toolboxview的路由跳转传递的参数
                // id:this.$route.params.id,
                id:this.$route.query.id,
                rules:{
                    instrName:[
                        { required:true,message:'请输入仪器设备名称',trigger:'blur'},
                    ],
                    instrNo:[
                        { required:true,message:'请输入规格型号',trigger:'blur'},
                    ],
                    instrNum:[
                        { required:true,message:'请输入仪器设备编号',trigger:'blur'},
                    ],
                }
            }
        },
        created() {
            this.load();
        },
        methods:{
            //时间格式
            formatDate(value, fmt) {
                if (value == null || value == '') {
                    return ""
                }
                let getDate = new Date(value);
                let o = {
                    'M+': getDate.getMonth() + 1,
                    'd+': getDate.getDate(),
                    'h+': getDate.getHours(),
                    'm+': getDate.getMinutes(),
                    's+': getDate.getSeconds(),
                    'q+': Math.floor((getDate.getMonth() + 3) / 3),
                    'S': getDate.getMilliseconds()
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                for (let k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                    }
                }
                return fmt;
            },
            load() {
                console.log("234567890====="+this.id)
                request.post( '/instrument/check',this.id).then( res => {

                    this.ticket = res
                    this.total=res.length;
                    this.getPageInfo();
                } )
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.currentPage = val
                this.getPageInfo()
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pageSize = val
                this.getPageInfo()
            },
            // 获取当前页的数据信息
            getPageInfo() {
                console.log("进入分页方法");
                //清空pageTicket中的数据
                this.instrument = [];
                // 获取当前页的数据
                for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
                    //把遍历的数据添加到pageTicket里面
                    this.instrument.push(this.ticket[i]);
                    //判断是否达到一页的要求
                    if (this.instrument.length === this.pageSize) break;
                }
            },
            //搜索
            sele(){
                if(this.instrName==null || this.instrName == "")
                {
                    this.$message( {
                        message: '请输入仪器设备名称',
                        type: 'warning'
                    } );
                    return ;
                }
                console.log("1200000")
                request.post( '/instrument/select', this.instrName ).then( res => {
                    this.ticket = res
                    this.total = res.length;
                    this.getPageInfo();
                    for (let i = 0; i < this.instrument.length; i++) {
                        console.log( "instrument.name" + this.instrument[i].name )
                    }
                    this.$message( {
                        message: '查询成功',
                        type: 'success'
                    } );
                } )

            },
            //删除操作
            dele (id) {
                // eslint-disable-next-line no-unused-vars
                this.$confirm('您确认删除吗','确认删除',{type:"warning"}).then(response =>{
                    request.post( '/instrument/delete',id).then( res => {
                        console.log( res )
                        this.$message.success( '删除成功')
                        //在第二页删除完数据，第一页还有数据，能够正确展示出第一页的数据
                        this.currentPage=1;
                        this.load()
                    } )
                }).catch(()=>{})
            },
            //修改操作
            toupdate(row) {
                console.log( "qqqq" )
                this.form2 = {}
                this.form2Visible = true //打开弹窗
                this.$nextTick(() => {
                    console.log("tttt");
                    setTimeout(() => {
                        this.$refs.form2.clearValidate();
                    }, 0);
                });
                console.log( "ttt" )
                this.form2 = JSON.parse( JSON.stringify( row ) );//这种拷贝方式，form2改变，row不会改变，点击确定保存后才会同步更改
                this.reData = JSON.parse( JSON.stringify( row ) )
            },
            save2(){
                console.log("rrrr")
                let b  =false ;
                for(let i=0;i<this.ticket.length;i++) {
                    if ( this.form2.instrNo == this.ticket[i].instrNo && this.form2.instrNo !=this.reData.instrNo) {
                        this.$message({
                            message: '规格型号不能重复',
                            type: 'warning'
                        });
                        b=true;
                        break;
                    }
                    if (this.form2.instrNum === this.ticket[i].instrNum  && this.form2.instrNum !==this.reData.instrNum) {
                        this.$message( {
                            message: '仪器设备编号不能重复',
                            type: 'warning'
                        } );
                        b=true
                        break;
                    }
                }
                if(b){
                    return false;
                }

                if(this.form2.instrName==null ||this.form2.instrName==''||this.form2.instrName==undefined)
                {
                    this.$message({
                        message: '仪器设备名称不为空',
                        type: 'warning'
                    });
                    return false;
                }
                console.log("-----uu")

                if(this.form2.instrNo==null||this.form2.instrNo==''||this.form2.instrNo==undefined)
                {
                    this.$message({
                        message: '规格型号不为空',
                        type: 'warning'
                    });
                    return false;

                }
                console.log("-----kk")
                if(this.form2.instrNum==null||this.form2.instrNum==''||this.form2.instrNum==undefined )
                {
                    this.$message({
                        message: '仪器设备编号不为空',
                        type: 'warning'
                    });
                    return false;
                }

                console.log("-----ii")

                // eslint-disable-next-line no-unused-vars
                request.post( '/instrument/update',this.form2 ).then( res => {
                    console.log( this.form2 );
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                    this.load()
                    this.form2Visible=false //关闭弹窗
                })
            },

            //新建仪器表
            handleAdd(){
                this.form={}
                this.formVisible=true //打开弹窗
                this.$nextTick(() => {
                    console.log("tttt");
                    setTimeout(() => {
                        this.$refs.form.clearValidate();
                    }, 0);
                });
            },
            save1(){
                this.form.createBy=localStorage.getItem("userName")
                let b  =false ;
                for(let i=0;i<this.ticket.length;i++) {
                    if ( this.form.instrNo == this.ticket[i].instrNo ) {
                        this.$message({
                            message: '规格型号不能重复',
                            type: 'warning'
                        });
                        b=true;
                        break;
                    }
                    if (this.form.instrNum === this.ticket[i].instrNum ) {
                        this.$message( {
                            message: '仪器编号不能重复',
                            type: 'warning'
                        } );
                        b=true
                        break;
                    }
                }
                if(b){
                    return false;
                }
                if(this.form.instrName==null ||this.form.instrName==''||this.form.instrName==undefined)
                {
                    this.$message({
                        message: '仪器设备名称不为空',
                        type: 'warning'
                    });
                    return false;
                }
                console.log("-----uu")

                if(this.form.instrNo==null||this.form.instrNo==''||this.form.instrNo==undefined)
                {
                    this.$message({
                        message: '规格型号不为空',
                        type: 'warning'
                    });
                    return false;

                }
                console.log("-----kk")
                if(this.form.instrNum==null||this.form.instrNum==''||this.form.instrNum==undefined )
                {
                    this.$message({
                        message: '仪器设备编号不为空',
                        type: 'warning'
                    });
                    return false;
                }
                console.log("-----ii")
                console.log("1111")
                console.log(this.id)
                //传过来的id号就是想传参到后端的toolId号，然后this.form有toolId这个属性，就可以直接赋值，然后传this.form，这样子把想传的id也传过去了
                this.form.toolId=this.id;
                // eslint-disable-next-line no-unused-vars
                request.post( '/instrument/add',this.form).then( res => {
                    console.log( this.form );
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.load()
                    this.formVisible=false //关闭弹窗
                })
            },
            refresh(){
                this.load()
                this.$message({
                    message: '刷新成功',
                    type: 'success'
                });
            },

            //v为用户的输入 nameCheck作用添加名字不重复
            //这里是this.ticket是因为在this.load中ticket接收了所有的数据
            nameCheck1 (v) {
                try {
                    this.ticket.forEach(item => {
                        if (item.instrNo == v)
                            throw new Error("instrNo-check-error");
                    })
                    return true
                } catch (e) {
                    if (e.message == "instrNo-check-error") {
                        this.$message({
                            message:'规格型号已存在',
                            type: 'warning'
                        })
                        return false
                    }
                }
            },
            nameCheck2 (v) {
                try {
                    this.ticket.forEach(item => {
                        if (item.instrNum == v)
                            throw new Error("instrNum-check-error");
                    })
                    return true
                } catch (e) {
                    if (e.message == "instrNum-check-error") {
                        this.$message({
                            message:'仪器设备编号已存在',
                            type: 'warning'
                        })
                        return false
                    }
                }
            }
        }


    }
</script>
<style>

</style>
